<div class="content-card" style="height: 100%;">
    <div style="height: 100%;">
        <ag-grid-angular
            *ngIf="!loadingIndicator"
            style="height: 100%;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [rowData]="rowData$ | async"
            [rowSelection]="'multiple'"
            (bodyScrollEnd)="onScrollEnd($event)"
            (firstDataRendered)="onLoaded($event)"
            (gridReady)="onGridReady($event)"
            (cellClicked)="onCellClicked($event)"
            (rowSelected)="onRowSelected($event)"
        ></ag-grid-angular>

        <div
            *ngIf="loadingIndicator"
            style="height: 100%;"
            class="campaign-result-spinner"
        >
            <mat-spinner color="accent"></mat-spinner>
        </div>
    </div>
</div>
